export const TagFilteringTheme = {
  Visible: "visible",
  Hidden: "hidden",
};
